import {Component, OnInit, OnDestroy, OnChanges, Input} from '@angular/core';
import {ServiceRequestService} from './../../../../../back-office/Services/service-request.service';
import {ServiceRequest} from './../../../../../back-office/Models/ServiceRequest';
import {Subscription} from 'rxjs';

@Component({
  selector: 'app-reply-step',
  templateUrl: './reply-step.component.html',
  styleUrls: ['./reply-step.component.scss']
})
export class ReplyStepComponent implements OnInit, OnDestroy, OnChanges {

  @Input() Index;

  public request: ServiceRequest = new ServiceRequest();
  private subscriptions: Subscription[] = [];
  public cardIsActive = false;
  public solutionSteps = [];

  constructor(
    private requestService: ServiceRequestService,
  ) {
  }

  ngOnInit() {
    this.load();
  }

  ngOnDestroy() {
    this.subscriptions.forEach(s => s.unsubscribe());
  }

  ngOnChanges() {
    this.subscriptions.forEach(s => s.unsubscribe());
    this.subscriptions = [];
    this.load();
  }

  private load() {
    this.subscriptions.push(
      this.requestService.serviceRequest.subscribe(serviceRequest => {
        this.request = serviceRequest;
        this.cardIsActive = this.checkCardActivation(this.Index);
        const steps = [];
        for (const replyItem of serviceRequest.reply.replyItems) {
          steps.push(replyItem.solutionStep);
        }
        this.solutionSteps = steps.filter((item) => !item.restricted);
      })
    );
  }

  private checkCardActivation(index) {
    if (index === 0) {
      return true;
    }
    if (this.request.reply.replyItems[index] && this.request.reply.replyItems[index].skipped) {
      return false;
    }
    if (this.request.reply.replyItems[index - 1]) {
      if (this.request.reply.replyItems[index - 1].skipped) {
        return true;
      } else {
        return this.request.reply.replyItems[index - 1].isDone;
      }
    }
  }

}
